var modules_8f2c8bee = {"container":"_7hfxoi","input-animation":"_ey8xgs","important":"_1dqrw9d"};
import "../../../assets/DGrJM2sQ.css";

export { modules_8f2c8bee as default };
//# sourceMappingURL=MaskInput.module.less.js.map
